import { Job, JobType } from 'interfaces/job';

import { getJobTypeDisplayLabel } from './jobTypeLabels';

export type RelatedJobsSortField = 'type' | 'job' | 'status';

export const RELATED_JOBS_FILTER_ALL = 'all';

const relatedJobStatusSortOrder: Record<string, number> = {
  failed: 0,
  failed_to_start: 1,
  pending: 2,
  running: 3,
  cancelled: 4,
  completed: 5,
  skip: 6,
};

export const getRelatedJobSortValue = (
  relatedJob: Partial<Job>,
  sortField: RelatedJobsSortField,
  getSubtaskStatusLabel: (status?: string) => string
) => {
  if (sortField === 'type') {
    return getJobTypeDisplayLabel(relatedJob.type as JobType).toLowerCase();
  }

  if (sortField === 'status') {
    const status = relatedJob.status || '';
    const priority = relatedJobStatusSortOrder[status] ?? Number.MAX_SAFE_INTEGER;
    return `${priority}-${getSubtaskStatusLabel(status).toLowerCase()}`;
  }

  return (relatedJob.id || '').toLowerCase();
};
